import axios from "axios";
import { apiBaseUrl, clientBaseUrl } from "../urls";
import { clearAccessToken, getTenant, removeTenant } from "../../utils/tenant";
import { getKeycloak, logout, updateToken } from "../../auth/keycloak";

const instance = axios.create({ baseURL: apiBaseUrl });

export default instance;

let installed = false;

export function setupAxios() {
  if (installed) return;
  installed = true;

  instance.interceptors.request.use((config) => {
    const tenant = getTenant();
    if (!tenant) {
      window.location = clientBaseUrl;
      return config;
    }

    config.headers.tenant = tenant.name;

    const kc = getKeycloak();
    if (!kc?.token) {
      return config;
    }

    return updateToken(5)
      .then(() => {
        config.headers.Authorization = `Bearer ${kc.token}`;
        return config;
      })
      .catch(() => {
        removeTenant();
        window.location = clientBaseUrl;
        return config;
      });
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        removeTenant();
        clearAccessToken();
        logout();
      }
      return Promise.reject(error);
    },
  );
}
